import { client } from "venuescanner-js/services/socketClient";

const counts = ({ inboxService, states }) => {
  /**
   * @typedef {Object} counts - Object containing the counts
   * @property {past_counts} new - Object containing the counts for NEW threads
   * @property {past_counts} open - Object containing the counts for OPEN threads
   * @property {past_counts} booked - Object containing the counts for BOOKED threads
   * @property {past_counts} closed - Object containing the counts for CLOSED threads
   */

  /**
   * @typedef {Object} indicators - Object containing the indicators
   * @property {past_counts} new - Object containing the counts for NEW threads
   * @property {past_counts} open - Object containing the counts for OPEN threads
   * @property {past_counts} booked - Object containing the counts for BOOKED threads
   * @property {past_counts} closed - Object containing the counts for CLOSED threads
   */

  return {
    /** @function
     * @async
     * @name counts.all
     * @desc Returns thread counts by statuses and states
     * @memberof! module:inboxService
     * @param options {object}
     * @param {String[]} [options.venueIds] - An array of Venue IDs, to check the threads across
     * @returns {counts}
     */
    all: async function ({ venueIds, filter }) {
      return client.sendPromise("room", {
        getStatusCounts: { venueIds, filter },
      });
    },
    /** @function
     * @async
     * @name counts.getIndicators
     * @memberof! module:inboxService
     * @desc Returns getIndicators for the user
     * @returns {indicators}
     */
    indicators: async function () {
      return client.sendPromise("room", {
        getIndicators: {},
      });
    },
  };
};
export default counts;
